/** Gestión interna de Instructor: documentos y pagos registrados manualmente. */
export const TIPOS_GESTION = [
    'contacto',
    'perfil',
    'contrato',
    'factura',
    'pago',
    'reversion',
    'ticket',
    'respuesta',
];
export const PERFIL_GESTION_ID = 'perfil-institucional-0001';
export const CAMPOS_GESTION = {
    perfil: [
        { nombre: 'nombre', etiqueta: 'Nombre institucional', requerido: true },
        { nombre: 'rut', etiqueta: 'RUT institucional', requerido: true },
        {
            nombre: 'tipo',
            etiqueta: 'Tipo de institución',
            opciones: ['municipalidad', 'hospital', 'servicio_salud', 'otro'],
            requerido: true,
        },
        { nombre: 'comuna', etiqueta: 'Comuna', requerido: true },
        { nombre: 'region', etiqueta: 'Región', requerido: true },
    ],
    contacto: [
        { nombre: 'nombre', etiqueta: 'Nombre', requerido: true },
        { nombre: 'cargo', etiqueta: 'Cargo' },
        { nombre: 'email', etiqueta: 'Correo', tipo: 'email', requerido: true },
        { nombre: 'telefono', etiqueta: 'Teléfono' },
        {
            nombre: 'funcion',
            etiqueta: 'Responsabilidad',
            opciones: ['comercial', 'tecnica', 'facturacion', 'contraparte'],
            requerido: true,
        },
        { nombre: 'estado', etiqueta: 'Estado', opciones: ['activo', 'inactivo'], requerido: true },
        { nombre: 'notas', etiqueta: 'Seguimiento / onboarding', tipo: 'area' },
    ],
    contrato: [
        { nombre: 'titulo', etiqueta: 'Nombre del contrato', requerido: true },
        { nombre: 'referencia', etiqueta: 'Número / referencia', requerido: true },
        { nombre: 'ordenCompra', etiqueta: 'Referencia de orden de compra' },
        { nombre: 'inicio', etiqueta: 'Inicio', tipo: 'fecha', requerido: true },
        { nombre: 'termino', etiqueta: 'Término', tipo: 'fecha', requerido: true },
        { nombre: 'monto', etiqueta: 'Monto total (CLP)', tipo: 'dinero', requerido: true },
        {
            nombre: 'estado',
            etiqueta: 'Estado',
            opciones: ['borrador', 'vigente', 'finalizado'],
            requerido: true,
        },
        { nombre: 'responsable', etiqueta: 'Responsable interno' },
        { nombre: 'notas', etiqueta: 'Condiciones / renovación', tipo: 'area' },
    ],
    factura: [
        { nombre: 'numero', etiqueta: 'Número de factura externa', requerido: true },
        { nombre: 'contratoId', etiqueta: 'Contrato', tipo: 'referencia', referencia: 'contrato' },
        { nombre: 'emision', etiqueta: 'Emisión', tipo: 'fecha', requerido: true },
        { nombre: 'vencimiento', etiqueta: 'Vencimiento', tipo: 'fecha', requerido: true },
        { nombre: 'periodo', etiqueta: 'Período / concepto', requerido: true },
        { nombre: 'total', etiqueta: 'Total facturado (CLP)', tipo: 'dinero', requerido: true },
        {
            nombre: 'estado',
            etiqueta: 'Estado del documento',
            opciones: ['emitida', 'anulada'],
            requerido: true,
        },
        { nombre: 'razonSocial', etiqueta: 'Razón social de facturación', requerido: true },
        { nombre: 'rut', etiqueta: 'RUT de facturación', requerido: true },
        { nombre: 'direccion', etiqueta: 'Dirección de facturación' },
        { nombre: 'notas', etiqueta: 'Observaciones', tipo: 'area' },
    ],
    pago: [
        {
            nombre: 'facturaId',
            etiqueta: 'Factura',
            tipo: 'referencia',
            referencia: 'factura',
            requerido: true,
        },
        { nombre: 'fecha', etiqueta: 'Fecha de pago', tipo: 'fecha', requerido: true },
        { nombre: 'monto', etiqueta: 'Monto recibido (CLP)', tipo: 'dinero', requerido: true },
        { nombre: 'referencia', etiqueta: 'Referencia del comprobante', requerido: true },
        { nombre: 'medio', etiqueta: 'Medio', opciones: ['transferencia', 'otro'], requerido: true },
        { nombre: 'notas', etiqueta: 'Observaciones', tipo: 'area' },
    ],
    ticket: [
        { nombre: 'titulo', etiqueta: 'Asunto', requerido: true },
        { nombre: 'descripcion', etiqueta: 'Descripción', tipo: 'area', requerido: true },
        {
            nombre: 'prioridad',
            etiqueta: 'Prioridad',
            opciones: ['baja', 'media', 'alta', 'critica'],
            requerido: true,
        },
        {
            nombre: 'estado',
            etiqueta: 'Estado',
            opciones: ['abierto', 'en_curso', 'resuelto', 'cerrado'],
            requerido: true,
        },
        { nombre: 'solicitante', etiqueta: 'Solicitante / contacto', requerido: true },
        { nombre: 'responsable', etiqueta: 'Responsable interno' },
        { nombre: 'plazo', etiqueta: 'Fecha objetivo de resolución', tipo: 'fecha' },
    ],
    reversion: [
        {
            nombre: 'pagoId',
            etiqueta: 'Pago a revertir',
            tipo: 'referencia',
            referencia: 'pago',
            requerido: true,
        },
        { nombre: 'fecha', etiqueta: 'Fecha de reversión', tipo: 'fecha', requerido: true },
        { nombre: 'referencia', etiqueta: 'Referencia de la corrección', requerido: true },
    ],
    respuesta: [
        {
            nombre: 'visibilidad',
            etiqueta: 'Visibilidad del mensaje',
            opciones: ['interna', 'institucion'],
        },
        {
            nombre: 'ticketId',
            etiqueta: 'Ticket',
            tipo: 'referencia',
            referencia: 'ticket',
            requerido: true,
        },
        { nombre: 'mensaje', etiqueta: 'Seguimiento / respuesta', tipo: 'area', requerido: true },
    ],
};
export const ROLES_OPERADOR = [
    'OPERADOR_ADMIN',
    'OPERADOR_FINANZAS',
    'OPERADOR_SOPORTE',
    'OPERADOR_LECTURA',
];
const CAPACIDADES = {
    OPERADOR_ADMIN: [
        'operadores.gestionar',
        'clientes.ver',
        'clientes.gestionar',
        'finanzas.ver',
        'finanzas.gestionar',
        'soporte.ver',
        'soporte.gestionar',
        'auditoria.ver',
    ],
    OPERADOR_FINANZAS: ['clientes.ver', 'finanzas.ver', 'finanzas.gestionar'],
    OPERADOR_SOPORTE: ['clientes.ver', 'soporte.ver', 'soporte.gestionar'],
    OPERADOR_LECTURA: ['clientes.ver', 'finanzas.ver', 'soporte.ver', 'auditoria.ver'],
};
export function capacidadesOperador(roles) {
    return [...new Set(roles.flatMap((r) => CAPACIDADES[r]))];
}
export function capacidadGestion(tipo, escritura) {
    const modulo = ['contrato', 'factura', 'pago', 'reversion'].includes(tipo)
        ? 'finanzas'
        : ['ticket', 'respuesta'].includes(tipo)
            ? 'soporte'
            : 'clientes';
    return `${modulo}.${escritura ? 'gestionar' : 'ver'}`;
}
export function saldoFactura(registro) {
    return registro.tipo === 'factura' && registro.datos.estado !== 'anulada'
        ? Number(registro.datos.total) - (registro.pagado ?? 0)
        : 0;
}
export const ROLES_EQUIPO = ['OPERADOR_FINANZAS', 'OPERADOR_SOPORTE', 'OPERADOR_LECTURA'];
//# sourceMappingURL=gestion.js.map